import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'preregistroClicked';
const listeners = new Set();
let cached = null;

const broadcast = (n) => {
  cached = n;
  listeners.forEach((fn) => fn(n));
};

export const trackPreregistroClick = () => {
  if (sessionStorage.getItem(SESSION_KEY)) return;
  sessionStorage.setItem(SESSION_KEY, '1');
  if (cached !== null) broadcast(cached + 1);
  fetch(`${API}/api/preregistro/click`, { method: 'POST', keepalive: true })
    .then((r) => r.json())
    .then((d) => typeof d.count === 'number' && broadcast(d.count))
    .catch(() => {});
};

export const usePreregistroCount = () => {
  const [count, setCount] = useState(cached);
  useEffect(() => {
    listeners.add(setCount);
    if (cached === null) {
      fetch(`${API}/api/preregistro/count`)
        .then((r) => r.json())
        .then((d) => typeof d.count === 'number' && broadcast(d.count))
        .catch(() => {});
    }
    return () => listeners.delete(setCount);
  }, []);
  return count;
};
